import { render, staticRenderFns } from "./ArchivedLocations.vue?vue&type=template&id=37d865b8&scoped=true&"
import script from "./ArchivedLocations.vue?vue&type=script&lang=js&"
export * from "./ArchivedLocations.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedLocations.vue?vue&type=style&index=0&id=37d865b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d865b8",
  null
  
)

export default component.exports